import Vue from 'vue'
import async from 'async'

export default {
  getPackages ({ commit }) {
    return async.waterfall([(next) => {
      Vue.api.get('engine/packages/wordpress')
        .then((res) => next(null, { wordpress: res.data }))
        .catch(next)
    }, (packages, next) => {
      Vue.api.get('engine/packages/laravel')
        .then((res) => next(null, { ...packages, laravel: res.data }))
        .catch(next)
    }]).then((packages) => commit('init', { packages })).catch(() => {})
  }
}
